import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const SELECTED_ITEM_CONTENT =
  new InjectionToken<SelectedItemContentDirective>('SelectedItemContent');

@Directive({
  selector: '[appSelected]',
  providers: [
    {
      provide: SELECTED_ITEM_CONTENT,
      useExisting: SelectedItemContentDirective,
    },
  ],
  standalone: false,
})
export class SelectedItemContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
